import apiService from './api.service';
import { API_ENDPOINTS } from '@/constants/api.constants';
import { logger } from '@/utils/logger';
import type { ApiResponse } from '@/types/api.types';
import type { Participant } from '@/types/entities';

export class ParticipantService {
    // Получение всех спортсменов (только для админов)
    static async getAllParticipants(): Promise<ApiResponse<Participant[]>> {
        try {
            const response = await apiService.get<ApiResponse<Participant[]>>(
                `${API_ENDPOINTS.PARTICIPANTS.BASE}`
            );
            return response.data;
        } catch (error) {
            logger.error('Error fetching all participants:', error);
            throw error;
        }
    }

    // Получение спортсменов клуба (для менеджеров)
    static async getClubParticipants(clubId: number): Promise<ApiResponse<Participant[]>> {
        try {
            const response = await apiService.get<ApiResponse<Participant[]>>(
                `${API_ENDPOINTS.CLUBS.BASE}/${clubId}/participants`
            );
            return response.data;
        } catch (error) {
            logger.error('Error fetching club participants:', error);
            throw error;
        }
    }

    // Получение конкретного спортсмена
    static async getParticipant(id: number): Promise<ApiResponse<Participant>> {
        try {
            const response = await apiService.get<ApiResponse<Participant>>(
                `${API_ENDPOINTS.PARTICIPANTS.BASE}/${id}`
            );
            return response.data;
        } catch (error) {
            logger.error(`Error fetching participant ${id}:`, error);
            throw error;
        }
    }
}

export default ParticipantService;